import { render, staticRenderFns } from "./HeadGradeInfo.vue?vue&type=template&id=fff11b4a&"
import script from "./HeadGradeInfo.vue?vue&type=script&lang=js&"
export * from "./HeadGradeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports